import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

const MAP = {
  success: { icon: CheckCircle2, color: "text-green-400", bg: "bg-green-500/15", title: "Payment Successful!",
    desc: "Your courses are unlocked. Start learning right away.", cta: ["Go to My Dashboard", "/dashboard"] },
  failed: { icon: XCircle, color: "text-red-400", bg: "bg-red-500/15", title: "Payment Failed",
    desc: "Your payment could not be completed. No charge was made — please try again.", cta: ["Back to Courses", "/courses"] },
  pending: { icon: Clock, color: "text-amber-400", bg: "bg-amber-500/15", title: "Payment Pending",
    desc: "We're confirming your payment. This can take a moment.", cta: ["Go to Dashboard", "/dashboard"] },
};

export default function PaymentResult() {
  const { status } = useParams();
  const s = MAP[status] || MAP.pending;
  const Icon = s.icon;
  return (
    <div className="max-w-lg mx-auto px-6 py-28 text-center" data-testid={`payment-${status}`}>
      <div className={`h-16 w-16 rounded-full ${s.bg} grid place-items-center mx-auto mb-6`}>
        <Icon className={`h-9 w-9 ${s.color}`} />
      </div>
      <h1 className="font-display text-4xl font-extrabold tracking-tight">{s.title}</h1>
      <p className="text-slate-600 mt-4">{s.desc}</p>
      <Link to={s.cta[1]} data-testid="payment-cta" className="btn-primary inline-block mt-8 px-8 py-4">{s.cta[0]}</Link>
    </div>
  );
}
